<template>
    <div
        v-if="isPermission"
        class="view-import"
    >
        <div class="view-import__steps">
            <step-bar 
                :steps="steps"
                :activeStepId="activeStepId"
            />
        </div>
        <div class="view-import__content">
            <div class="view-import__title">{{steps[activeStepId].title}}</div>
            <message
                v-if="taskMessage !== ''"
                :text="taskMessage"
                :styleClass="{
                    color: '#fff',
                    background: '#3CB371',
                    padding: '5px 0 5px 20px',
                    margin: '5px 0 5px 0',
                    'border-radius': '10px'
                }"
            />
            <view-import-attach
                v-if="activeStepId === 0"
                :isPreloader="isPreloader"
                @onClickSubmit="importAddTask" 
            />
            <view-import-run
                v-if="activeStepId === 1 || activeStepId === 2"
                :activeStepId="activeStepId"
                :statusBarPercent="statusBarPercent"
                :isButtonsShow="isImportRun"
                :importReportsTableTabs="importReportsTableTabs"
                :canUpload="canUpload"
                @onClickCancel="onClickCancel"
                @onClickUpload="onClickUpload"
            />
        </div>
    </div>
    <div v-else>
        У вас нет прав на доступ к импорту
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import StepBar from '../../components/Base/StepBar';
import ViewImportAttach from './ViewImportAttach';
import ViewImportRun from './ViewImportRun';
import Message from '../../components/Base/Message';
import serviceAuth from '../../services/serviceAuth';
import serviceApi from '../../services/serviceApi';
import schemeApi from '../../schemes/schemeApi';
import schemeImport from '../../schemes/schemeImport';
let {routeImportRun, routeImportAddTask, routeImportCheckTask} = schemeApi;
let {reportColumns} = schemeImport;
export default {
    name: 'ViewImport',
    components: {
        StepBar,
        ViewImportAttach,
        ViewImportRun,
        Message
    },
    /**
     * данные компонета
     * @property {boolean} isPermission - право на показ
     * @property {array} steps - шаги
     * @property {number} activeStepId - активный шаг
     * @property {string} fileId - идентификатор файла
     * @property {boolean} isImportRun - запушен ли импорт
     * @property {boolean} isImportUpload - запущена ли загрузка
     * @property {number} importStepCurrent - текущий шаг импорта
     * @property {number} importStepTotal - всего шагов импорта
     * @property {array} importReports - отчеты об ошибках валидации файла
     * @property {object} importReportsColumns - колонки для таблицы отчетов валидации файла
     * @property {boolean} isPreloader - условие показа прелоадера
     * @property {string} taskId - идентификатор задачи
     * @property {string} taskMessage - сообщение о статусе задачи
     * @property {boolean} readyTask - условия завершения задачи
     * @property {number} timerId - идентификатор таймера
     * @property {boolean} canUpload - проверка на наличие ошибок
     * @property {boolean} isClear - флаг очистки старых данных
     */
    data: () => ({
        isPermission: false,
        steps: [
            {
                id: 0,
                name: "1 - Прикрепить файл",
                title: "Прикрепить файл"
            },
            {
                id: 1,
                name: "2 - Проверка файла",
                title: "Проверка файла"
            },
            {
                id: 2,
                name: "3 - Загрузка файла",
                title: "Загрузка файла"
            }
        ],
        activeStepId: 0,
        fileId: null,
        isImportRun: false,
        isImportUpload: false,
        importStepCurrent: 0,
        importStepTotal: 0,
        importReports: [],
        importReportsColumns: new Map(Object.entries(reportColumns)),
        isPreloader: false,
        
        taskId: null,
        taskMessage: '',
        readyTask: false,
        timerId: null,
        canUpload: false,
        isNotClear: false
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} activeProjectId - id активного проекта
         */
        ...mapState({
            activeProjectId: state => state.activeProjectId
        }),
        /**
         * данные валидации импорта
         * @returns {object}
         */
        importRunPostData() {
            let data = {
                file_id: this.fileId,
                step: this.importStepCurrent
            }
            return data;
        },
        /**
         * данные для загрузки
         * @returns {object}
         */
        importUploadPostData() {
            let data = {
                file_id: this.fileId,
                step: this.importStepCurrent,
                upload: 1,
                is_clear: !this.isNotClear
            }
            return data;
        },
        /**
         * данные для проверки задачи
         * @returns {object}
         */
        importCheckTaskPostData() {
            let data = {
                task_id: this.taskId,
            }
            return data;
        },
        /**
         * процент для статус-бара
         * @returns {number}
         */
        statusBarPercent() {
            let percent = (this.importStepTotal === 0) ? 0 : ((this.importStepCurrent) / this.importStepTotal) * 100;
            return percent;
        },
        /**
         * таблица отчета об ошибках разбитая по табам
         * @returns {object}
         */
        importReportsTableTabs() {
            let rowsError = this.importReports.filter((row) => row.type === 1);
            let rowsWarning = this.importReports.filter((row) => row.type === 2);
            let rowsDuplicate = this.importReports.filter((row) => row.type === 3);
            let cellClear = this.importReports.filter((row) => row.type === 4);
            let cellEmptyData = this.importReports.filter((row) => row.type === 5);

            let tableTabs = {
                error: {
                    title: rowsError.length > 0 ? `Ошибки ${rowsError.length}` : `Ошибки`,
                    tableData: {
                        columns: this.importReportsColumns,
                        rows: rowsError
                    }
                },
                warning: {
                    title: rowsWarning.length > 0 ? `Предупреждения ${rowsWarning.length}` : `Предупреждения`,
                    tableData: {
                        columns: this.importReportsColumns,
                        rows: rowsWarning
                    }
                },
                dublicate: {
                    title: rowsDuplicate.length > 0 ? `Дубли строк ${rowsDuplicate.length}` : `Дубли строк`,
                    tableData: {
                        columns: this.importReportsColumns,
                        rows: rowsDuplicate
                    }
                },
                cellClear: {
                    title: cellClear.length > 0 ? `Очистка полей ${cellClear.length}` : `Очистка полей`,
                    tableData: {
                        columns: this.importReportsColumns,
                        rows: cellClear
                    }
                },
                cellEmptyData: {
                    title: cellEmptyData.length > 0 ? `Пустые ячейки с данными ${cellEmptyData.length}` : `Пустые ячейки с данными`,
                    tableData: {
                        columns: this.importReportsColumns,
                        rows: cellEmptyData
                    }
                }
            }
            return tableTabs;
        }
    },
    mounted() {
        // устанавливаем текущее название страницы
        this.setCurrentViewName("Импорт");
        // получаем право на отображение
        this.isPermission = serviceAuth.checkPermission(this.activeProjectId, 'can_import');
    },
    methods: {
        /**
         * проксируем мутации из стора
         * @property {Function} setCurrentViewName - установить текущее имя страницы
         */
        ...mapMutations([
            'setCurrentViewName'
        ]),
        /**
         * добавить задачу в очередь
         * @async
         * @param {object} data - данные формы
         * @param {boolean} isNotClear
         */
        async importAddTask(data, isNotClear) {
            this.isNotClear = isNotClear;
            this.taskMessage = "Пожалуйста, подождите"
            this.isPreloader = true;
            try {
                let result = await serviceApi.post(routeImportAddTask, data);
                let {file_id: fileId = null, task_id: taskId = null} = result.data;
                this.fileId = fileId;
                this.taskId = taskId;
                if (fileId !== null && taskId !== null) {
                    this.importCheckTask();
                }

            }
            catch(error) {
                this.taskMessage = ''
                if (error.response.data.message) 
                    alert(error.response.data.message);
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен'); 
            }
        },
        /**
         * проверить статус задачи
         * @async
         */
        async importCheckTask() {
            this.timerId = setInterval(async () => {
                try {
                    let result = await serviceApi.post(routeImportCheckTask, this.importCheckTaskPostData);
                    let {ready = false, message = '', errors = false} = result.data;
                    this.readyTask = ready;
                    this.taskMessage = message;
                    if (errors !== false) {
                        this.taskMessage = '';
                        clearInterval(this.timerId);
                        alert('Не удалось прикрепить файл');
                    }
                    if(ready === true) {
                        clearInterval(this.timerId);
                        this.isPreloader = false;
                        this.activeStepId++;
                        this.taskMessage = '';
                        this.importRun('validation');
                    }
                }
                catch(error) {
                    this.taskMessage = '';
                    clearInterval(this.timerId);
                    if (error.response.data.message) 
                        alert(error.response.data.message);
                    if (error.message === 'not server')
                        alert('Извините, сервер временно недоступен');
                }
            }, 30000);
        },
        /**
         * событие запуска импорта
         * @async
         * @param {string} type - тип импорта (валидация, загрузка)
         */
        async importRun(type = 'validation') {
            this.isImportRun = true;
            while (this.statusBarPercent < 100) {
                let postData = (type === 'validation') ? this.importRunPostData : this.importUploadPostData
                try {
                    let result = await serviceApi.post(routeImportRun, postData);
                    let {steps_total: stepTotal, reports = []} = result.data;
                    this.importStepTotal = Number(stepTotal);
                    this.importReports = [...this.importReports, ...reports];
                    this.importStepCurrent += 1;

                    let except = this.importReports.filter((row) => row.type !== 3 & row.type !== 4);

                    this.canUpload = !except.length;
                }
                catch(error) {
                    if (error.response.data.message) 
                        alert(error.response.data.message);
                    if (error.message === 'not server')
                        alert('Извините, сервер временно недоступен');
                    break;
                }
            }
            this.isImportRun = false;
        },
        /**
         * событие клика по кнопке закрытия
         */
        onClickCancel() {
            this.refresh();
            this.activeStepId = 0;
        },
        /**
         * событие клика по кнопке загрузки
         */
        onClickUpload() {
           this.refresh();
           this.activeStepId++;
           this.importReports = [];
           this.importRun('upload');
        },
        /**
         * очистить данные представления 
         */
        refresh() {
            this.isImportRun = false;
            this.importStepCurrent = 0;
            this.importStepTotal = 0;
            this.importReports = [];
        },
    }
}
</script>

<style lang="scss" scoped>
    %view-import-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .view-import {
        @extend %view-import-container;

        margin-top: 10px;
        padding: 20px 25px;
        background: #fff;
        border-radius: 14px;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
    }
    .view-import__steps {
        margin: 20px 20px 20px 20px;
    }
    .view-import__content {
        width: 100%;
    }
    ::v-deep .view-import__btn-container {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    ::v-deep .view-import__title {
        font-size: 22px;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 10px;
    }
</style>